module.exports = __webpack_public_path__ + "static/media/nursingliquid.7d960061.pdf";